import {TaxonomyFieldsMap} from './taxonomy.types';
import _mapValues from 'lodash/mapValues';

function toClientTaxonomyFieldsMap(fieldsMap: TaxonomyFieldsMap): TaxonomyFieldsMap {
  return _mapValues(fieldsMap, (fields) => {
    return fields.sort((a, b) => {
      if (a?.isRequired && !b?.isRequired) return -1;
      if (b?.isRequired && !a?.isRequired) return 1;

      if (a.key.replace(/\d+$/, '') === b.key.replace(/\d+$/, '')) {
        return +a.key.replace(/^.+\D(\d+)$/, '$1') - +b.key.replace(/^.+\D(\d+)$/, '$1');
      }

      return a.key.toUpperCase() > b.key.toUpperCase() ? 1 : -1;
    });
  });
}

export {toClientTaxonomyFieldsMap};
